// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WBO2","comment":"styles_comment__K3o1y"};